import { AuthService } from '@anecdotes/auth-core';
import { AbstractSupportConfigService, SupportConfig } from '@anecdotes/support';
import { Injectable } from '@angular/core';
import { Observable, combineLatest, map } from 'rxjs';
import { CustomerFacadeService } from '@anecdotes/data-store';

@Injectable()
export class SupportConfigService extends AbstractSupportConfigService {
  constructor(private customerService: CustomerFacadeService, private authService: AuthService) {
    super();
  }

  getConfig(): Observable<SupportConfig> {
    return combineLatest([this.customerService.getCurrentCustomer(), this.authService.getUser()]).pipe(
      map(([currentCustomer, currentUser]) => ({
        customerId: currentUser.customer_id,
        customerName: currentCustomer.customer_name,
        userName: currentUser.name,
        userEmail: currentUser.email,
      })),
    );
  }
}
